import { DashboardAction, WindowEventType } from '@shared/extension';

export function notifyDashboard() {
  window.postMessage({ type: WindowEventType.FromDashboard, action: DashboardAction.ExtensionInstalled }, '*');
}
